import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { TYPOGRAPHY } from "@tCentro/theme/design";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    extendedStyles?: NISProductFinePrintStyles;
    finePrint?: string;
}

type Props = OwnProps;

export interface NISProductFinePrintStyles {
    wrapper?: InjectableCss;
    finePrint?: TypographyProps;
}

export const nisProductFinePrintStyles: NISProductFinePrintStyles = {
    wrapper: {
        css: css`
            margin: 8px 0px 8px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin: 4px 0px 16px;
                    `,
                    css`
                        margin: 4px 0px 16px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    finePrint: {
        css: css`
            font-weight: ${TYPOGRAPHY.weight.base};
            font-size: ${TYPOGRAPHY.size.tiny};
            line-height: 16px;
            font-family: Roboto;
        `,
    },
};

const styles = nisProductFinePrintStyles;

const NISProductFinePrint: FC<Props> = ({ finePrint }) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.finePrint}>{finePrint}</StyledWrapper>
        </StyledWrapper>
    );
};

export default NISProductFinePrint;
